import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import { initFromEntries } from '../../utils/util'
import 'lib-flexible'

// 兼容旧版本
if (!Object?.fromEntries) initFromEntries()

Promise.prototype.finally =
  Promise.prototype.finally ||
  {
    finally(fn) {
      const onFinally = (callback) => Promise.resolve(fn()).then(callback)
      return this.then(
        (result) => onFinally(() => result),
        (reason) => onFinally(() => Promise.reject(reason))
      )
    }
  }.finally

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
)
